import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="container">

        <div className="ft-social">
          <div>
            {/* Facebook */}
            <a href="https://www.facebook.com/people/My-Cinemas/61579515805543/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#1877F2" />
                <path
                  d="M15.117 8.667h-1.84c-.288 0-.61.378-.61.884v1.329h2.45l-.34 2.38h-2.11V21h-2.55v-7.74H8.5v-2.38h1.617V9.56c0-1.65 1.12-3.56 3.56-3.56h1.44v2.667z"
                  fill="#FFFFFF"
                />
              </svg>
            </a>


            {/* Instagram */}
            <a href="https://www.instagram.com/mycinemasindia/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient id="ig" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#feda75" />
                    <stop offset="25%" stopColor="#fa7e1e" />
                    <stop offset="50%" stopColor="#d62976" />
                    <stop offset="75%" stopColor="#962fbf" />
                    <stop offset="100%" stopColor="#4f5bd5" />
                  </linearGradient>
                </defs>

                <rect width="24" height="24" rx="6" fill="url(#ig)" />

                <rect
                  x="5"
                  y="5"
                  width="14"
                  height="14"
                  rx="4"
                  ry="4"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1.5"
                />

                <circle cx="12" cy="12" r="2.8" fill="none" stroke="#fff" strokeWidth="1.5" />

                <circle cx="17.5" cy="6.5" r="1.2" fill="#fff" />
              </svg>
            </a>

            <a href="https://youtube.com/@mycinemasonline?si=4SKuaPATWubLwAXL" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg
                width="30"
                height="30"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient id="yt" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ff0000" />
                    <stop offset="100%" stopColor="#cc0000" />
                  </linearGradient>
                </defs>

                {/* Red background */}
                <rect width="24" height="24" rx="3" fill="url(#yt)" />

                {/* YouTube play button triangle */}
                <polygon points="9.5,7 9.5,17 17,12" fill="#fff" />
              </svg>
            </a>


          </div>
        </div>
        {/* <div className="ft-social">
          <div>
            <a href="#">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="#80848E" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_438_1911)">
                <path d="M30 15.0898C30 22.5761 24.5075 28.7823 17.3375 29.9086V19.4548H20.8237L21.4875 15.1298H17.3375V12.3236C17.3375 11.1398 17.9175 9.98734 19.775 9.98734H21.6613V6.30484C21.6613 6.30484 19.9487 6.01234 18.3125 6.01234C14.895 6.01234 12.6625 8.08359 12.6625 11.8323V15.1286H8.86375V19.4536H12.6625V29.9073C5.49375 28.7798 0 22.5748 0 15.0898C0 6.80609 6.71625 0.0898438 15 0.0898438C23.2838 0.0898438 30 6.80484 30 15.0898Z" />
                </g>
                <defs>
                <clipPath id="clip0_438_1911">
                <rect width="30" height="30" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </a>
            <a href="#">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="#80848E" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_438_1914)">
                <path d="M8.57617 7.69922L19.6712 22.2055H21.3712L10.4024 7.69922H8.57617Z" />
                <path d="M15 0C6.71625 0 0 6.71625 0 15C0 23.2838 6.71625 30 15 30C23.2838 30 30 23.2838 30 15C30 6.71625 23.2838 0 15 0ZM18.8288 24.04L13.9913 17.7213L8.46375 24.04H5.39125L12.5575 15.8475L5 5.96H11.3275L15.695 11.7362L20.7488 5.96H23.8175L17.1162 13.6175L25 24.0388L18.8288 24.04Z" />
                </g>
                <defs>
                <clipPath id="clip0_438_1914">
                <rect width="30" height="30" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </a>
            <a href="#">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="#80848E" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_438_1919)">
                <path d="M15 2.7025C19.005 2.7025 19.48 2.7175 21.0613 2.79C22.6963 2.865 24.38 3.2375 25.5713 4.42875C26.7738 5.63125 27.135 7.29875 27.21 8.93875C27.2825 10.52 27.2975 10.995 27.2975 15C27.2975 19.005 27.2825 19.48 27.21 21.0613C27.1362 22.6875 26.755 24.3875 25.5713 25.5713C24.3688 26.7738 22.7025 27.135 21.0613 27.21C19.48 27.2825 19.005 27.2975 15 27.2975C10.995 27.2975 10.52 27.2825 8.93875 27.21C7.325 27.1362 5.6025 26.7463 4.42875 25.5713C3.2325 24.375 2.865 22.6913 2.79 21.0613C2.7175 19.48 2.7025 19.005 2.7025 15C2.7025 10.995 2.7175 10.52 2.79 8.93875C2.86375 7.31875 3.24875 5.60875 4.42875 4.42875C5.62875 3.22875 7.3025 2.865 8.93875 2.79C10.52 2.7175 10.995 2.7025 15 2.7025ZM15 0C10.9262 0 10.415 0.0175 8.815 0.09C6.49625 0.19625 4.19375 0.84125 2.5175 2.5175C0.835 4.2 0.19625 6.4975 0.09 8.815C0.0175 10.415 0 10.9262 0 15C0 19.0737 0.0175 19.585 0.09 21.185C0.19625 23.5012 0.84375 25.81 2.5175 27.4825C4.19875 29.1637 6.5 29.8037 8.815 29.91C10.415 29.9825 10.9262 30 15 30C19.0737 30 19.585 29.9825 21.185 29.91C23.5025 29.8037 25.8075 29.1575 27.4825 27.4825C29.1663 25.7987 29.8037 23.5025 29.91 21.185C29.9825 19.585 30 19.0737 30 15C30 10.9262 29.9825 10.415 29.91 8.815C29.8037 6.49625 29.1575 4.1925 27.4825 2.5175C25.8037 0.83875 23.4963 0.195 21.185 0.09C19.585 0.0175 19.0737 0 15 0Z" />
                <path d="M15.0004 7.29688C10.7466 7.29688 7.29785 10.7456 7.29785 14.9994C7.29785 19.2531 10.7466 22.7019 15.0004 22.7019C19.2541 22.7019 22.7029 19.2531 22.7029 14.9994C22.7029 10.7456 19.2541 7.29688 15.0004 7.29688ZM15.0004 19.9994C12.2391 19.9994 10.0004 17.7606 10.0004 14.9994C10.0004 12.2381 12.2391 9.99938 15.0004 9.99938C17.7616 9.99938 20.0004 12.2381 20.0004 14.9994C20.0004 17.7606 17.7616 19.9994 15.0004 19.9994Z" />
                <path d="M23.0075 8.79141C24.0016 8.79141 24.8075 7.98552 24.8075 6.99141C24.8075 5.99729 24.0016 5.19141 23.0075 5.19141C22.0134 5.19141 21.2075 5.99729 21.2075 6.99141C21.2075 7.98552 22.0134 8.79141 23.0075 8.79141Z" />
                </g>
                <defs>
                <clipPath id="clip0_438_1919">
                <rect width="30" height="30" fill="white"/>
                </clipPath>
                </defs>
              </svg>                                
            </a>
          </div>
        </div> */}
        <div className="ft-data">
          <p>© {new Date().getFullYear()} AARVJ GROUP PRIVATE LIMITED. All rights reserved.</p>
          <ul>
            <li>
              <Link to="/page/refund-cancellation-policy">Refund & Cancellation Policy</Link>
            </li>
            <li>
              <Link to="/page/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/page/terms-and-conditions">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <a href="#" onClick={(e) => { e.preventDefault(); if (window.openCookieSettings) window.openCookieSettings(); }}>Cookie Settings</a>
            </li>
            <li>
              <a href="/page/faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="ft-disclaimer" style={{ color: '#80848E' }}>
          <p><em><small>Facebook, YouTube, and Instagram are trademarks of their respective owners. We are not affiliated with or endorsed by these platforms.</small></em></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
